import Hls from 'hls.js';


let videoVimeo = {
    init() {

        var i = 0;
        $('video').each(function(){
            var video = $('video');
            $(this).attr('id', 'video'+i);
            var video = video[i];
            var videoSrc = $(video).data('src');
            if (Hls.isSupported()) {
                var hls = new Hls({
                    startLevel: 3
                });
                hls.loadSource(videoSrc);
                hls.attachMedia(video);
            }
            else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                video.src = videoSrc;
            }

            i++;
        })
    },
    videoPlay(id) {
        let v = $('video#' + id).get(0);
        if (typeof v != "undefined") {
            v.play();
        }

    },
    videoPause(id) {
        let v = $('video#' + id).get(0);
        if (typeof v != "undefined") {
            v.pause();
        }
    }
}

export default videoVimeo;
